import React from 'react';

import PageHero from '@/components/PageHero';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const privacyData = [
  {
    title: "1. Introduction and Scope",
    content: "This Privacy Policy outlines how ALTA-X, a product of 1st Group Capital (Pty) Ltd, collects, uses, protects, and discloses your personal information in compliance with the Protection of Personal Information Act (POPIA) of South Africa. This policy applies to all users of the ALTA-X platform, website, and associated services. Your privacy is of paramount importance to us, and we are committed to safeguarding your data while providing you with a seamless investment experience."
  },
  {
    title: "2. Information We Collect",
    content: "We collect information that is necessary to provide our services and meet our legal and regulatory obligations. This includes personal identification data (such as your name, ID number, and contact details), financial information (for investment and transaction purposes), and technical data (such as your IP address, browser type, and usage patterns on our site). Information is collected when you register, complete your profile, execute transactions, or interact with our support channels."
  },
  {
    title: "3. How We Use Your Information",
    content: "Your personal information is used to manage your account, process transactions, and provide you with customer support. We also use this data to comply with legal requirements, such as FICA, and to improve our platform's security and functionality. We may use your contact details to send you important updates about your account, our services, and marketing communications, from which you can opt-out at any time."
  },
  {
    title: "4. Data Sharing and Disclosure",
    content: "ALTA-X will not sell, rent, or trade your personal information. We may disclose your information to third-party service providers who assist us with business operations such as identity verification, payment processing, and IT services, under strict confidentiality agreements. We may also disclose information to regulatory or law enforcement agencies as required by law to prevent fraud or other illegal activities."
  },
  {
    title: "5. Data Security and Retention",
    content: "We implement robust technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. These measures include data encryption, access controls, and secure server infrastructure. We retain your personal information only for as long as necessary to fulfill the purposes for which it was collected and to comply with our legal and regulatory obligations."
  },
  {
    title: "6. Your Rights and Choices",
    content: "Under POPIA, you have the right to access, correct, or delete your personal information held by us. You also have the right to object to the processing of your data and to lodge a complaint with the Information Regulator of South Africa if you believe your rights have been infringed. To exercise your rights, please contact our data protection officer at privacy@alta-x.com."
  }
];

const PrivacyPolicy: React.FC = () => {
  return (
    <>
      <PageHero 
        title="Privacy Policy"
        subtitle="How we collect, use, and protect your personal information"
        backgroundImage="https://images.unsplash.com/photo-1614064548237-096537e54299?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
      />
      
      <main className="flex-grow">
        <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <Accordion type="single" collapsible defaultValue="item-1" className="w-full">
              {privacyData.map((item, index) => (
                <AccordionItem value={`item-${index + 1}`} key={index}>
                  <AccordionTrigger className="text-left">{item.title}</AccordionTrigger>
                  <AccordionContent className="prose prose-lg max-w-none text-gray-600">
                    {item.content.includes('privacy@alta-x.com') ? 
                      <p>Under POPIA, you have the right to access, correct, or delete your personal information held by us. You also have the right to object to the processing of your data and to lodge a complaint with the Information Regulator of South Africa if you believe your rights have been infringed. To exercise your rights, please contact our data protection officer at <a href="mailto:privacy@alta-x.com" className="text-blue-600 hover:underline">privacy@alta-x.com</a>.</p> 
                      : <p>{item.content}</p>
                    }
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </main>
    </>
  );
};

export default PrivacyPolicy;
